/* eslint-disable */
const Fetch_ORDER_STATS = 'Fetch_ORDER_STATS';
const SET_STATS_FILTERS = 'SET_STATS_FILTERS';

const initialState = {
  orders: [],
  filters: {
    productId: '',
    confirmerId: '',
    dateRange: 'week', // 'today', 'yesterday', 'week', 'month', 'custom'
    customStartDate: null,
    customEndDate: null,
  }
};

export const fetchOrderStats = (payload) => ({
  type: Fetch_ORDER_STATS,
  payload,
});

export const setStatsFilters = (payload) => ({
  type: SET_STATS_FILTERS,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Fetch_ORDER_STATS:
      return {
        ...state,
        orders: action.payload,
      };
    case SET_STATS_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
